import { performRequestSecond } from 'common/apiHandler';
import { default as apiEndPoints } from 'common/apiEndPoints';
import { getTenantDetails } from 'utils/utils';

/**
 * Create a new insurance provider
 * @param {Object} data - Insurance provider data
 * @returns {Promise} API response
 */
export const createInsurer = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.createInsurer}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&case_id=${data.case_id}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

/**
 * Update an existing insurance provider
 * @param {Object} data - Insurance provider data including insurer_pk and insurer_sk
 * @returns {Promise} API response
 */
export const updateInsurer = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.updateInsurer}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestSecond(apiEndPoints.methodType.PUT, url, data);
};

/**
 * Delete an insurance provider
 * @param {string} insurerPk - Insurance provider primary key
 * @param {string} insurerSk - Insurance provider sort key
 * @returns {Promise} API response
 */
export const deleteInsurer = (insurerPk, insurerSk) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.deleteInsurer}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&insurer_pk=${insurerPk}&insurer_sk=${insurerSk}`;
  return performRequestSecond(apiEndPoints.methodType.DELETE, url);
};

/**
 * List insurance providers for a case
 * @param {string} caseId - Case identifier
 * @param {number} pageLimit - Number of records per page (default: 10)
 * @param {string} pagination_token - Token for pagination
 * @param {string} pagination_direction - Direction for pagination ('forward' or 'backward', default: 'forward')
 * @returns {Promise} API response
 */
export const listInsurers = (caseId, pageLimit = 100, pagination_token = '', pagination_direction = 'forward', inputValue = '') => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${
    apiEndPoints.listInsurers
  }?tenant_id=${tenantId}&tenant_sk=${tenantSk}&case_id=${caseId}&limit=${pageLimit}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}${
    inputValue ? `&keyword=${inputValue}` : ''
  }`;
  return performRequestSecond(apiEndPoints.methodType.POST, url);
};
